import {
  Box,
  styled,
  Typography,
  Divider,
  Accordion,
  AccordionSummary,
} from "@mui/material"
import { colors } from "../../theme/colors"

export const Subtext = styled(Typography)({})

export const ContentContainer = styled(Box)({
  color: colors.darkGrey,
  width: "100%",
})

export const TopContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
})

export const ScrollContainer = styled(Box)({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  flex: 1,
  overflow: "auto",
  height: "100%",
  scrollbarWidth: "none",
})

export const CenterContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  marginTop: 10,
})

export const RecipientContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  marginTop: 10,
})

export const SourceDescription = styled(Typography)({
  color: colors.lightBlack,
  fontSize: 22,
  lineHeight: "24px",
  marginTop: 30,
  fontWeight: 400,
})

export const StatusChecked = styled("div")(
  ({ statusColor }: { statusColor: keyof typeof colors }) => ({
    color: colors[statusColor],
  }),
)

export const Amount = styled(Typography)({
  marginTop: 10,
  color: colors.lightBlack,
  fontSize: 42,
  fontWeight: "normal",
  height: 72,
})

export const StyledDivider = styled(Divider)({
  color: colors.darkGrey,
  marginTop: 60,
  marginBottom: 20,
  border: "2px dotted",
  borderTop: "none",
})

export const DetailsContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: 20,
})

export const DetailContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
})

export const DetailLabel = styled(Box)({
  color: colors.darkGrey,
  fontSize: 14,
  lineHeight: "18px",
})

export const DetailValue = styled(Box)({
  color: colors.lightBlack,
  fontSize: 18,
  lineHeight: "24px",
})

export const StyledAccordion = styled(Accordion)({
  margin: 0,
  boxShadow: "none",
  border: "none",
  "&:before": {
    position: "static",
  },
})

export const AccordionHeader = styled(AccordionSummary)({
  padding: 0,
  height: 24,
  minHeight: "24px !important",
  margin: "0 0 10px",
  "& .MuiAccordionSummary-content": {
    margin: 0,
    "& ..Mui-expanded": {
      margin: 0,
    },
  },
})

export const AccordionBody = styled(AccordionSummary)({
  padding: 0,
  marginBottom: 24,
})

export const IconContainer = styled(Box)({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  marginTop: "auto",
})

export const DetailsContainerTextOverflow = {
  overflowWrap: "anywhere",
}
